"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageDrop = exports.WidgetAction = void 0;
var EditorTypes_1 = require("./../EditorTypes");
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var WidgetActions = __importStar(require("./WidgetActions"));
var TelemetryParameterValue_1 = require("Telemetry/TelemetryParameterValue");
var Utils_1 = require("Project/QwilrEditor/Utils");
var UploadUtils_1 = require("Common/Upload/UploadUtils");
var lodash_1 = require("lodash");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
var WidgetAction;
(function (WidgetAction) {
    WidgetAction["ClickWidgetAdderItem"] = "clickWidgetAdderItem";
})(WidgetAction = exports.WidgetAction || (exports.WidgetAction = {}));
var WidgetBehaviour;
(function (WidgetBehaviour) {
    WidgetBehaviour["OnClickWidgetAdderItem"] = "onClickWidgetAdderItem";
})(WidgetBehaviour || (WidgetBehaviour = {}));
exports.default = (function (di, router) {
    var widgetAdderStore = di.get("widgetAdderStore");
    var currentBlockType = di.get("blockStore").blockType;
    var editorTelemetry = di.get("editorTelemetry");
    return {
        onImageUpdate: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("imageWidgetUpdate")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "image", action: "update" })
            .doAction(function (event, editor) {
            WidgetActions.updateImageWidget(editor, event.data.path, event.data.toUpdate);
            return true;
        }),
        onImageRemove: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("imageWidgetRemove")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "image", action: "delete" })
            .doAction(function (event, editor) {
            WidgetActions.removeWidget(editor, event.data.path);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.Image);
            return true;
        }),
        onImageChoose: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("imageWidgetChooseImage")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "image", action: "chooseImage" })
            .doAction(function (event, editor) {
            WidgetActions.chooseImage(editor, di, event.data.path);
            var _a = event.data, path = _a.path, _b = _a.modificationContext, modificationContext = _b === void 0 ? {} : _b;
            var origin = modificationContext.origin || "click";
            editorTelemetry.inlineContentAdded({
                contentType: TelemetryParameterValue_1.ContentAddedType.Image,
                origin: origin,
                blockType: currentBlockType,
                source: modificationContext.imageSource,
                isInsideSideBySide: (0, Utils_1.isInsideSideBySide)(editor, path),
            });
            return true;
        }),
        onAddImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("addWidgetImage")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "widgetAdder", action: "addImage" })
            .doAction(function (event, editor) {
            var _a = event.data, currentPath = _a.currentPath, _b = _a.modificationContext, modificationContext = _b === void 0 ? {} : _b;
            var origin = modificationContext.origin || "click";
            var imageData = event.data;
            delete imageData.modificationContext;
            delete imageData.currentPath;
            WidgetActions.addImageWidget(editor, imageData, currentPath);
            editorTelemetry.inlineContentAdded({
                contentType: TelemetryParameterValue_1.ContentAddedType.Image,
                origin: origin,
                blockType: currentBlockType,
                source: modificationContext.imageSource,
                isInsideSideBySide: (0, Utils_1.isInsideSideBySide)(editor, currentPath),
            });
            return true;
        }),
        onDropImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDropImage")
            .isEvent(EditorTypes_1.EventType.Drop)
            .doAction(function (event, editor) {
            if (!(0, exports.isImageDrop)(event)) {
                return false;
            }
            var uploadStore = di.get("uploadStore");
            var dropLocationStore = di.get("dropLocationStore");
            var usingDropIndicators = di.get("usingFeature")(FeatureFlag_1.default.SidebarImages);
            if (usingDropIndicators && !dropLocationStore.dropLocation) {
                return false;
            }
            WidgetActions.insertImagesFromDragEvent(event, editor, uploadStore, dropLocationStore, usingDropIndicators);
            editorTelemetry.imageDraggedInto(currentBlockType, (0, Utils_1.isInsideSideBySide)(editor));
            return true;
        }),
        onDropImageOnEmptyImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDropImageOnEmptyImage")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "image", action: "dropImage" })
            .doAction(function (event, editor) {
            var uploadStore = di.get("uploadStore");
            var file = event.data.file;
            var uploadId = uploadStore.upload(file);
            WidgetActions.updateImageWidget(editor, event.data.path, {
                uploadId: uploadId,
            });
            editorTelemetry.imageDraggedInto(currentBlockType, (0, Utils_1.isInsideSideBySide)(editor));
            return true;
        }),
        onDropTokenOnImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDropTokenOnImage")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "image", action: "dropVariable" })
            .doAction(function (event, editor) {
            var variable = event.data.variable;
            WidgetActions.updateImageWidget(editor, event.data.path, {
                src: "",
                variable: {
                    label: variable.name,
                    name: variable.apiName,
                    substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(variable),
                },
            });
            editorTelemetry.variableInserted(variable, {
                tokenInsertedOrigin: "drag",
                tokenInsertedBlockType: currentBlockType,
                tokenInsertedInlineContentType: "image",
            });
            return true;
        }),
        onVideoUpdate: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("videoWidgetUpdate")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "video", action: "update" })
            .doAction(function (event, editor) {
            WidgetActions.updateVideoWidget(editor, event.data.path, event.data.toUpdate);
            return true;
        }),
        onDropTokenOnVideo: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDropTokenOnVideo")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "video", action: "dropVariable" })
            .doAction(function (event, editor) {
            var variable = event.data.variable;
            WidgetActions.updateVideoWidget(editor, event.data.path, {
                variable: {
                    label: variable.name,
                    name: variable.apiName,
                    substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(variable),
                },
            });
            editorTelemetry.variableInserted(variable, {
                tokenInsertedOrigin: "drag",
                tokenInsertedBlockType: currentBlockType,
                tokenInsertedInlineContentType: "video",
            });
            return true;
        }),
        onVideoRemove: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("videoWidgetRemove")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "video", action: "delete" })
            .doAction(function (event, editor) {
            WidgetActions.removeWidget(editor, event.data.path);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.Video);
            return true;
        }),
        onGoogleMapsUpdate: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("googleMapsWidgetUpdate")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.GoogleMaps, action: "update" })
            .doAction(function (event, editor) {
            WidgetActions.updateGoogleMapsWidget(editor, event.data.path, event.data.toUpdate);
            return true;
        }),
        onDropTokenOnGoogleMaps: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDropTokenOnGoogleMaps")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.GoogleMaps, action: "dropVariable" })
            .doAction(function (event, editor) {
            var variable = event.data.variable;
            WidgetActions.updateGoogleMapsWidget(editor, event.data.path, {
                variable: {
                    label: variable.name,
                    name: variable.apiName,
                    substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(variable),
                },
            });
            editorTelemetry.variableInserted(variable, {
                tokenInsertedOrigin: "drag",
                tokenInsertedBlockType: currentBlockType,
                tokenInsertedInlineContentType: "map",
            });
            return true;
        }),
        onGoogleMapsRemove: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("googleMapsWidgetRemove")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.GoogleMaps, action: "delete" })
            .doAction(function (event, editor) {
            WidgetActions.removeWidget(editor, event.data.path);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.GoogleMaps);
            return true;
        }),
        onIframeUpdate: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("iframeUpdate")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Iframe, action: "update" })
            .doAction(function (event, editor) {
            WidgetActions.updateIframeWidget(editor, event.data.path, event.data.toUpdate);
            return true;
        }),
        onDropTokenOnIframe: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDropTokenOnIframe")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Iframe, action: "dropVariable" })
            .doAction(function (event, editor) {
            var variable = event.data.variable;
            WidgetActions.updateIframeWidget(editor, event.data.path, {
                variable: {
                    label: variable.name,
                    name: variable.apiName,
                    substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(variable),
                },
            });
            editorTelemetry.variableInserted(variable, {
                tokenInsertedOrigin: "drag",
                tokenInsertedBlockType: currentBlockType,
                tokenInsertedInlineContentType: "map",
            });
            return true;
        }),
        onIframeRemove: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("iframeRemove")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Iframe, action: "delete" })
            .doAction(function (event, editor) {
            WidgetActions.removeWidget(editor, event.data.path);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.Iframe);
            return true;
        }),
        onTogglePlus: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("togglePlus")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "widgetAdder", action: "togglePlus" })
            .doAction(function (event, editor) {
            WidgetActions.togglePlus(editor, event.data.location, widgetAdderStore, editorTelemetry);
            return true;
        }),
        onKeyboardPlus: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("keyboardPlus")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Plus)
            .withModifier(BehaviourBuilder_1.KeyModifier.Any)
            .inBlockType([EditorTypes_1.BlockType.Paragraph])
            .hasTextSequence(/^$/)
            .doAction(function (event, editor) {
            editorTelemetry.viewedAdderMenu(widgetAdderStore.isParagraphCentered, "keyboard");
            return false;
        }),
        onWidgetAdderEnter: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onWidgetAdderEnter")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .selectionIsCollapsed()
            .hasTextSequence(/^\+[a-zA-Z0-9 ]*$/)
            .doAction(function (event, editor) {
            var isMenuClosed = widgetAdderStore.shouldForceCloseMenu;
            if (widgetAdderStore.widgetAdderOptions(editor).length === 0 || isMenuClosed) {
                WidgetActions.closeWidgetAdderAndAddNewLine(widgetAdderStore, editor);
                return false;
            }
            event.preventDefault();
            var selectedWidgetType = widgetAdderStore.widgetTypeToAdd(editor);
            var telemetryInlineContentAdded = function (contentType) {
                return editorTelemetry.inlineContentAdded({
                    contentType: contentType,
                    origin: TelemetryParameterValue_1.ContentAddedOrigin.Keyboard,
                    blockType: currentBlockType,
                    isInsideSideBySide: (0, Utils_1.isInsideSideBySide)(editor),
                });
            };
            return WidgetActions.addWidgetShortcut(editor, di, router, widgetAdderStore, selectedWidgetType, {
                origin: TelemetryParameterValue_1.ContentAddedOrigin.Keyboard,
            }, telemetryInlineContentAdded);
        }),
        onClickWidgetAdderItem: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(WidgetBehaviour.OnClickWidgetAdderItem)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "widgetAdder", action: WidgetAction.ClickWidgetAdderItem })
            .doAction(function (event, editor) {
            var selectedWidgetType = event.data.selectedWidgetType;
            var modificationContext = {
                origin: TelemetryParameterValue_1.ContentAddedOrigin.Click,
            };
            var sendTelemetryInlineContentAdded = function (contentType) {
                editorTelemetry.inlineContentAdded({
                    contentType: contentType,
                    origin: modificationContext.origin,
                    blockType: currentBlockType,
                    isInsideSideBySide: (0, Utils_1.isInsideSideBySide)(editor),
                });
            };
            return WidgetActions.addWidgetShortcut(editor, di, router, widgetAdderStore, selectedWidgetType, modificationContext, sendTelemetryInlineContentAdded);
        }),
        onWidgetAdderUpKey: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onWidgetAdderUpKey")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowUp)
            .selectionIsCollapsed()
            .hasTextSequence(/^\+[a-zA-Z]*$/)
            .doAction(function (event, editor) {
            return WidgetActions.moveSelectedWidgetType(event, widgetAdderStore, BehaviourBuilder_1.KeyType.ArrowUp, editorTelemetry, editor);
        }),
        onWidgetAdderDownKey: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onWidgetAdderDownKey")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowDown)
            .selectionIsCollapsed()
            .hasTextSequence(/^\+[a-zA-Z]*$/)
            .doAction(function (event, editor) {
            return WidgetActions.moveSelectedWidgetType(event, widgetAdderStore, BehaviourBuilder_1.KeyType.ArrowDown, editorTelemetry, editor);
        }),
        onWidgetAdderEsc: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onWidgetAdderDownKey")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Escape)
            .selectionIsCollapsed()
            .hasTextSequence(/^\+[a-zA-Z]*$/)
            .doAction(function (event, editor) {
            return WidgetActions.closeWidgetAdder(event, widgetAdderStore);
        }),
        onEnterInsideWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onEnterInsideWidget")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .selectionIsCollapsed()
            .inBlockType([
            EditorTypes_1.BlockType.Video,
            EditorTypes_1.BlockType.GoogleMaps,
            EditorTypes_1.BlockType.Iframe,
            EditorTypes_1.BlockType.HorizontalRule,
            EditorTypes_1.BlockType.Button,
            EditorTypes_1.BlockType.ROICalculator,
        ])
            .doAction(function (event, editor) {
            event.preventDefault();
            WidgetActions.newParagraphBelowWidget(editor);
            return true;
        }),
        onBackspaceAfterWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("backspaceAfterWidget")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .inBlockType(EditorTypes_1.BlockType.Any)
            .atStartOfBlock()
            .selectionIsCollapsed()
            .hasBlockBefore(WidgetActions.WidgetsWithBackspaceBehaviourEnabled)
            .doAction(function (event, editor) {
            return WidgetActions.onBackspaceAfterWidget(event, editor);
        }),
    };
});
var isImageDrop = function (event) {
    if (!event.dataTransfer.items) {
        return false;
    }
    var files = Array.from(event.dataTransfer.items);
    var nonImages = (0, lodash_1.filter)(files, function (file) { return !(0, UploadUtils_1.isImage)(file); });
    return files.length > 0 && nonImages.length === 0;
};
exports.isImageDrop = isImageDrop;
